import T from '@wojtekmaj/react-t';

import { BackButton, Title as HeaderWithButtonTitle, Wrapper } from './header_with_button.styles';

import Title from '../../title';

type HeaderWithButtonProps = {
  backButtonMode?: 'back' | 'up';
  children?: string;
};

export default function HeaderWithButton({ backButtonMode, children }: HeaderWithButtonProps) {
  return (
    <>
      <Title>{children}</Title>
      <Wrapper>
        <BackButton mode={backButtonMode} />
        <HeaderWithButtonTitle>
          <T>{children}</T>
        </HeaderWithButtonTitle>
      </Wrapper>
    </>
  );
}
